import styled from "styled-components";

const FilterSearchStyle = styled.input`
  width: 272px;
  height: 36px;
  background:var(--color-workspace-bg-page-area);
  border: 1px solid var(--color-table-border-pageinput);
  margin-bottom: 15px;
  margin-top: 70px;
  font-size: 14px;


  &:focus-visible {
    outline-color: #EC407A;
  }
  
`;

const FilterSearch = (props) => {
    const setSearch = props.setSearch;
  return(
      <>
        <FilterSearchStyle type={"text"} id={"filter_blueprint"}  placeholder=" Search BluePrint..." onChange={(event) => {setSearch(event.target.value)}} />
      </>
  );
}

export default FilterSearch;
